import React from 'react';
import { Field, useFormikContext } from 'formik';
import { FormattedMessage } from 'react-intl';
import { DropdownComponent } from '../../../../../components/prime-formik';

const SuperProfileRequiredJobSeniority = () => {
  const { setFieldValue } = useFormikContext();

  const requiredJobSeniorityOptions = [
    { label: 'None', value: 'NONE' },
    { label: '0-2 years', value: 'ZERO_TO_TWO_YEARS' },
    { label: '3-4 years', value: 'THREE_TO_FOUR_YEARS' },
    { label: '5+ years', value: 'FIVE_PLUS_YEARS' },
  ];

  return (
    <div className="p-col-12">
      <div className="flex-space-between">
        <FormattedMessage
          id="account.super-profiles.new.required-job-seniority"
          defaultMessage="Required job seniority/experience"
        >
          {(text) => (
            <label className="field-label" htmlFor="requiredJobSeniority">
              {text}
            </label>
          )}
        </FormattedMessage>
        <FormattedMessage id="select" defaultMessage="Select">
          {(text) => (
            <Field
              id="requiredJobSeniority"
              name="requiredJobSeniority"
              component={DropdownComponent}
              options={requiredJobSeniorityOptions}
              filter
              filterBy="label,value"
              className="right"
              onChange={(event) => {
                setFieldValue('requiredJobSeniority', event.value);
              }}
              placeholder={`-- ${text} --`}
            />
          )}
        </FormattedMessage>
      </div>
    </div>
  );
};

export default SuperProfileRequiredJobSeniority;
